// extracted by mini-css-extract-plugin
export default {"itemNewsEvent":"newsAndEvents_itemNewsEvent__dt6um","title":"newsAndEvents_title__E6L36","date":"newsAndEvents_date__siAOU"};